// Kurze Länder-Auswahlliste (nur iso + nameDE) für die Settings-Länderauswahl.
// Leitet sich aus der gemeinsamen Karten-Registry shared/countryMaps.ts ab, damit
// diese Liste nicht mehr von Hand gepflegt werden muss und nicht auseinanderlaufen
// kann, wenn ein Land hinzugefügt/entfernt wird. Siehe auch die vollständigen
// Registries client/lib/countryMaps.ts (Mobile) + web/src/lib/planning/countryMaps.ts.
import { COUNTRY_MAPS as SHARED_COUNTRY_MAPS } from "../../../shared/countryMaps";

export interface CountryMapConfig {
  iso: string;
  nameDE: string;
}

export const COUNTRY_MAPS: CountryMapConfig[] = SHARED_COUNTRY_MAPS.map((c) => ({
  iso: c.iso,
  nameDE: c.nameDE,
}));

export const SORTED_COUNTRY_MAPS = [...COUNTRY_MAPS].sort((a, b) =>
  a.nameDE.localeCompare(b.nameDE, "de"),
);

export function getCountryMapConfig(iso: string): CountryMapConfig | null {
  const u = (iso || "").toUpperCase();
  return COUNTRY_MAPS.find((c) => c.iso === u) ?? null;
}

export function getCountryFlag(isoCode: string | null | undefined): string {
  const c = (isoCode || "").toUpperCase();
  if (!/^[A-Z]{2}$/.test(c)) return "\uD83C\uDF10";
  const A = 0x1f1e6;
  const a = "A".charCodeAt(0);
  return String.fromCodePoint(A + (c.charCodeAt(0) - a)) + String.fromCodePoint(A + (c.charCodeAt(1) - a));
}
